import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HubspotService {
  conversationsAPIReady = false;
  onConversationsAPIReady$ = new Subject();
  widgetLoaded = false;

  private scriptKey = environment.HUBSPOT_SCRIPT_KEY;

  init(): Subject<unknown> | any {
    const se: any = document.createElement('script');
    const responseSubj = new Subject();
    se.type = 'text/javascript';
    se.async = true;
    se.defer = true;
    se.id = 'hs-script-loader';
    se.src = `//js.hs-scripts.com/${this.scriptKey}.js`;
    se.onload = se['onreadystatechange'] = function () {
      responseSubj.next(true);
    };
    const _hsq = (window['_hsq'] = window['_hsq'] || []);
    _hsq.push(['setContentType', 'CONTENT_TYPE']);
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(se, s);
    return responseSubj;
  }

  authUserInHubSpot(user, company_id, iframeId = null): Observable<any> {
    window['hsConversationsSettings'] = {
      loadImmediately: false
    };
    const _hsq = (window['_hsq'] = window['_hsq'] || []);
    _hsq.push(['setContentType', 'CONTENT_TYPE']);

    const identifyObj = {
      email: user.email,
      company_id: company_id,
      phone: user?.phone,
      firstName: user?.first_name,
      lastName: user?.last_name
    };

    _hsq.push(['identify', identifyObj]);

    return this.init().pipe(
      map(() => {
        this.initChatSettings(user, iframeId);
      })
    );
  }

  defaultChatSettings(): void {
    document.body.classList.add('hbs-chat');
    window['hsConversationsSettings'] = {
      loadImmediately: false
    };
  }

  initChatSettings(user, iframeId): void {
    window['hsConversationsSettings'] = {
      email: user['email'],
      firstName: user['first_name'],
      lastName: user['last_name'],
      loadImmediately: false,
      disableAttachment: true,
      identificationEmail: user['email'],
      identificationToken: user['hubspot_token']
    };

    if (iframeId) {
      window['hsConversationsSettings']['inlineEmbedSelector'] = iframeId;
    }

    // @ts-ignore
    if (window.HubSpotConversations) {
      this.onConversationsAPIReady();
    } else {
      // @ts-ignore
      window.hsConversationsOnReady = [
        () => {
          this.onConversationsAPIReady();
        }
      ];
    }
  }

  onConversationsAPIReady(): void {
    console.log('HubSpotConversations api ready');
    this.conversationsAPIReady = true;
    this.onConversationsAPIReady$.next(window['HubSpotConversations']);
  }

  loadWidget(open = false): void {
    if (this.widgetLoaded && open) {
      this.showWidget();
      this.openWidget();
    } else {
      document.body.classList.add('hubspot-chat');
      window['HubSpotConversations'].widget.load({ widgetOpen: open });

      setTimeout(() => {
        const chatContainerParent = document.getElementById('hubspot-messages-iframe-container');
        if (chatContainerParent) {
          this.toggleWidget(open);
        } else {
          setTimeout(() => {
            this.toggleWidget(open);
          }, 2000);
        }
      }, 2000);
    }
  }

  toggleWidget(open): void {
    if (open) {
      this.showWidget();
      this.openWidget();
    } else {
      this.openWidget();
    }

    this.widgetLoaded = true;
    this.listenCommunication();
  }

  openWidget(): void {
    setTimeout(() => {
      window['HubSpotConversations'].widget.open();
    }, 300);
  }

  closeWidget(): void {
    setTimeout(() => {
      window['HubSpotConversations'].widget.close();
    });
  }

  removeWidget(): void {
    window['HubSpotConversations'].widget.remove();
  }

  resetWidget(): void {
    window['HubSpotConversations'].widget.refresh();
    window['HubSpotConversations'].clear({ resetWidget: true });
  }

  listenCommunication(): void {
    window['HubSpotConversations'].on('conversationStarted', (payload) => {
      console.log(`Started conversation with id ${payload.conversation.conversationId}`);

      this.showWidget();
      this.openWidget();
    });

    window['HubSpotConversations'].on('unreadConversationCountChanged', (payload) => {
      console.log(`New unread count is ${payload.unreadCount}!`);
      this.showWidget();
      // this.openWidget();
    });
  }

  hideWidget(): void {
    setTimeout(() => {
      const chatContainerParent = document.getElementById('hubspot-messages-iframe-container');
      if (chatContainerParent) {
        chatContainerParent.style.setProperty('z-index', '-99999', 'important');
        document.body.classList.remove('hubspot-chat');
      }
    });
  }

  showWidget(): void {
    setTimeout(() => {
      const chatContainerParent = document.getElementById('hubspot-messages-iframe-container');
      if (chatContainerParent) {
        chatContainerParent.style.zIndex = '99999';
        document.body.classList.add('hubspot-chat');
        document.body.classList.remove('hbs-chat');
      }
    });
  }
}
